<div class="title_div">
    <div class="w-100 d-flex justify-content-between align-items-center">
        <div class="proj_id d-flex">
            <div class="title_sub_div_1">
                <!-- <i class="fa fa-bell me-2" style="font-size: 24px; text-shadow: 0 2px 4px rgba(0,0,0,0.15);"></i> -->
                Part Alert
            </div>
        </div>
        <div>
            <i class="fa fa-home" (click)="home()" title="Dashboard"></i>
        </div>
    </div>
</div>
<div class="stat-cards-row">
    <div class="stat-card stat-card-total">
        <div class="stat-card-body">
            <div class="stat-card-info">
                <div class="stat-card-number">{{ partsDetails?.length || 0 }}</div>
                <div class="stat-card-label">Total Parts</div>
            </div>
            <div class="stat-card-icon">
                <i class="fa fa-folder-open"></i>
            </div>
        </div>
    </div>

    <div class="stat-card stat-card-unique">
        <div class="stat-card-body">
            <div class="stat-card-info">
                <div class="stat-card-number">{{ uniquePartsCount }}</div>
                <div class="stat-card-label">Unique Parts</div>
            </div>
            <div class="stat-card-icon">
                <i class="fa fa-gem"></i>
            </div>
        </div>
    </div>

    <div class="stat-card stat-card-available">
        <div class="stat-card-body">
            <div class="stat-card-info">
                <div class="stat-card-number">{{ availablePartsCount }}</div>
                <div class="stat-card-label">Available</div>
            </div>
            <div class="stat-card-icon">
                <i class="fa fa-check-circle"></i>
            </div>
        </div>
    </div>

    <div class="ml-auto d-flex align-items-center">
        <button type="button" class="btn-add-part" 
            title="Add part number for alert" (click)="openPartModel(addPartModal)">
            <span class="btn-add-part-icon">
                <i class="fa fa-plus"></i>
            </span>
            <span class="btn-add-part-text">Add Part</span>
        </button>
    </div>
</div>

<div class="table-responsive gd_main_div_mobile">
    <table class="table table-striped custom-hover">
        <thead>
            <!-- Column Headers -->
            <tr>
                <th *ngFor="let col of tableHeaders; let i = index">
                    {{ col.label }}
                    <i  class="fa fa-chevron-down"  style="font-size: 9px; cursor: pointer;" (click)="toggleSearch(i)"></i>
                </th>
                <th>Action</th> <!-- Static Action header -->
            </tr>

            <!-- Filter Inputs -->
            <tr *ngIf="showSearch">
                <th *ngFor="let col of tableHeaders; let i = index">
                    <input *ngIf="showSearchRow[i]" type="text" class="form-control form-control-sm"
                        [(ngModel)]="searchValues[i]" (input)="filterData(searchValues[i])"
                        placeholder="Search {{ col.label }}" />
                </th>
                <th></th> 
            </tr>
        </thead>

        <tbody>
            <tr *ngFor="let row of filteredPartsDetails; let i = index">
                <td *ngFor="let col of tableHeaders">
                    <ng-container *ngIf="col.key === 'status'; else normalCell">
                        <span [ngClass]="{
  'status-available': row[col.key]?.toLowerCase() === 'available',
  'status-pending': row[col.key]?.toLowerCase() === 'pending'
}">
                            {{ row[col.key] }}
                        </span>

                        <i *ngIf="row[col.key] === 'Available'" class="fa fa-circle-info text-primary ms-2"
                            title="View Details" style="cursor: pointer" (click)="viewStatusDetails(row)">
                        </i>
                    </ng-container>

                    <ng-container *ngIf="col.key === 'frequency_id' && row[col.key]">
                        <span class="frequency-text">{{ getFrequencyLabel(row[col.key]) }}</span>
                    </ng-container>

                    <ng-template #normalCell>
                        {{ col.key !== 'frequency_id' ? row[col.key] : '' }}
                    </ng-template>
                    <ng-template #normalCell>
                        <ng-container *ngIf="col.key === 'sourcing_type'">
                            <span *ngIf="Array.isArray(row[col.key])">
                                {{ row[col.key].join(', ') }}
                            </span>
                            <span *ngIf="!Array.isArray(row[col.key])">
                                {{ row[col.key] }}
                            </span>
                        </ng-container>

                        <ng-container *ngIf="col.key !== 'sourcing_type'">
                            {{ col.key === 'frequency_id' ? getFrequencyLabel(row[col.key]) : row[col.key] }}
                        </ng-container>
                    </ng-template>

                </td>

              
                <td>
  <i class="fa fa-trash text-danger circle-icon"
     title="Delete"
     (click)="deleteModel(deletemod, i)"></i>
</td>

            </tr>
        </tbody>

    </table>
</div>



<ng-template #addPartModal let-modal>
    <div class="modal-header">
        <h6 class="modal-title">
            <i class="fa fa-cube"></i>
            Add Part Number
        </h6>
        <button type="button" class="btn-close" (click)="modal.dismiss('Close')"></button>
    </div>
    
    <div class="modal-body">
        <form [formGroup]="partForm">
            <!-- Project Selection Section -->
            <div class="form-section">
                <h6><i class="fa fa-project-diagram"></i>Project Information</h6>
                <div class="form-row-group">
                    <div class="form-group-modern">
                        <label for="projectName" class="form-label">Project Name</label>
                        <select id="projectName" class="form-control form-select" formControlName="projectName"
                            (change)="onSelectProject()">
                            <option value="" disabled selected>Select Project</option>
                            <option *ngFor="let pro of projectNameDetails" [value]="pro.projectName">
                                {{ pro.projectName }}
                            </option>
                        </select>
                        <div *ngIf="partForm.get('projectName')?.invalid && partForm.get('projectName')?.touched" 
                            class="form-validation-error">
                            Project is required
                        </div>
                    </div>

                    <div class="form-group-modern">
                        <label for="versionId" class="form-label">Version Id</label>
                        <select id="versionId" class="form-control form-select" formControlName="version_id"
                            (change)="onSelectVersion()">
                            <option value="" disabled selected>Select Version</option>
                            <option *ngFor="let ver of availableVersions" [value]="ver">
                                {{ ver }}
                            </option>
                        </select>
                        <div *ngIf="partForm.get('version_id')?.invalid && partForm.get('version_id')?.touched" 
                            class="form-validation-error">
                            Version is required
                        </div>
                    </div>
                </div>
            </div>

            <!-- Part Selection Section -->
            <div class="form-section">
                <h6><i class="fa fa-microchip"></i>Part Information</h6>
                <div class="form-row-group">
                    <div class="form-group-modern">
                        <label for="internalPartNo" class="form-label">Internal Part No.</label>
                        <select id="internalPartNo" class="form-control form-select" formControlName="internalPartNo"
                            (change)="onSelectInternalPart()">
                            <option value="" disabled selected>Select Internal Part</option>
                            <option *ngFor="let part of internalPartList" [value]="part.internalPartNo">
                                {{ part.internalPartNo }}
                            </option>
                        </select>
                        <div *ngIf="partForm.get('internalPartNo')?.invalid && partForm.get('internalPartNo')?.touched" 
                            class="form-validation-error">
                            Internal Part No. is required
                        </div>
                    </div>

                    <div class="form-group-modern">
                        <label for="MPN" class="form-label">MPN</label>
                        <input type="text" id="MPN" class="form-control" formControlName="MPN" />
                        <div *ngIf="partForm.get('MPN')?.invalid && partForm.get('MPN')?.touched" 
                            class="form-validation-error">
                            MPN is required
                        </div>
                    </div>

                    <div class="form-group-modern">
                        <label for="manufacturer" class="form-label">Make</label>
                        <input type="text" id="manufacturer" class="form-control" formControlName="manufacturer" />
                        <div *ngIf="partForm.get('manufacturer')?.invalid && partForm.get('manufacturer')?.touched" 
                            class="form-validation-error">
                            Make is required
                        </div>
                    </div>

                    <div class="form-group-modern">
                        <label for="uom" class="form-label">UOM</label>
                        <input type="text" id="uom" class="form-control" formControlName="uom" />
                        <div *ngIf="partForm.get('uom')?.invalid && partForm.get('uom')?.touched" 
                            class="form-validation-error">
                            UOM is required
                        </div>
                    </div>
                </div>
            </div>

            <!-- Details Section -->
            <div class="form-section">
                <h6><i class="fa fa-dna"></i>Specifications</h6>
                <div class="form-row-group">
                    <div class="form-group-modern">
                        <label for="requiredQuantity" class="form-label">Required Quantity</label>
                        <input type="number" id="requiredQuantity" class="form-control"
                            formControlName="requiredQuantity" min="1" />
                        <div *ngIf="partForm.get('requiredQuantity')?.invalid && partForm.get('requiredQuantity')?.touched" 
                            class="form-validation-error">
                            Quantity must be greater than 0
                        </div>
                    </div>

                    <div class="form-group-modern">
                        <label for="frequency" class="form-label">Frequency</label>
                        <select id="frequency" class="form-control form-select" formControlName="frequency">
                            <option *ngFor="let option of frequencyOptions" [ngValue]="option">
                                {{ option.scheduleType }}
                            </option>
                        </select>
                    </div>
                </div>
            </div>
        </form>
    </div>

    <div class="modal-footer">
        <button type="button" class="btn btn-outline-primary" (click)="closeModal()">
            <i class="fa fa-times me-2"></i>
            Close
        </button>
        <button type="submit" class="btn btn-primary" (click)="addPart()" [disabled]="partForm.invalid">
            <i class="fa fa-plus me-2"></i>
            Add Part
        </button>
    </div>
</ng-template>

<ng-template #deletemod let-modal>
    <div class="modal-header">
        <h5 class="modal-title">Confirm Delete</h5>
        <button type="button" class="close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        Are you sure you want to delete this item?
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-danger" (click)="onYesToDelete()">Yes, Delete</button>
        <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Cancel</button>
    </div>
</ng-template>

<!-- Custom Modal: Part Availability Details -->
<div *ngIf="showModal" class="custom-modal-overlay" (click)="close()">
    <div class="custom-modal-content" (click)="$event.stopPropagation()">
        <!-- Header -->
        <div class="custom-modal-header">
            <div class="modal-header-left">
                <div class="modal-icon-badge">
                    <i class="fa fa-circle-info"></i>
                </div>
                <div>
                    <h5 class="modal-title-text">Part Availability Details</h5>
                    <p class="modal-subtitle-text">Real-time supplier pricing & stock overview</p>
                </div>
            </div>
            <button type="button" class="close-button" (click)="close()" title="Close">
                <i class="fa fa-times"></i>
            </button>
        </div>

        <!-- Body -->
        <div class="custom-modal-body">
            <!-- Summary Info Block -->
            <div class="table-info-block">
                <div class="info-item">
                    <span class="info-label">
                        <i class="fa fa-barcode me-1 text-primary"></i> MPN
                    </span>
                    <span class="info-value mpn-highlight">{{ selectedPart?.mpn || 'N/A' }}</span>
                </div>
                <div class="info-item">
                    <span class="info-label">
                        <i class="fa fa-industry me-1 text-primary"></i> Make
                    </span>
                    <span class="info-value">{{ selectedPart?.manufacturer || 'N/A' }}</span>
                </div>
                <div class="info-item">
                    <span class="info-label">
                        <i class="fa fa-folder-open me-1 text-primary"></i> Project Name
                    </span>
                    <span class="info-value">{{ selectedPart?.project_name || 'N/A' }}</span>
                </div>
            </div>

            <!-- Table Container -->
            <div class="modal-table-container">
                <table class="table modal-custom-table w-100">
                    <thead>
                        <tr>
                            <th>Supplier</th>
                            <th class="text-center">Availability</th>
                            <th class="text-end">Price</th>
                            <th class="text-center">UOC</th>
                            <th class="text-center">SPQ</th>
                            <th class="text-center">MOQ</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of selectedPart?.supplier_availability">
                            <td class="supplier-cell">
                                <a *ngIf="item.clickUrl" [href]="item.clickUrl" target="_blank" rel="noopener noreferrer" class="supplier-link" title="Open Supplier Page">
                                    <span>{{ item.supplier }}</span>
                                    <i class="fa fa-external-link-alt ms-1" style="font-size: 10px;"></i>
                                </a>
                                <span *ngIf="!item.clickUrl" class="supplier-name">{{ item.supplier }}</span>
                            </td>
                            <td class="text-center">
                                <span class="avail-badge" [ngClass]="{'avail-positive': item.TotalAvail > 0, 'avail-zero': !item.TotalAvail || item.TotalAvail === 0 || item.TotalAvail === '0'}">
                                    {{ item.TotalAvail ?? '-' }}
                                </span>
                            </td>
                            <td class="text-end fw-semibold text-dark">
                                {{ (item.Price !== null && item.Price !== undefined) ? (item.Price | number:'1.2-4') : '-' }}
                            </td>
                            <td class="text-center">
                                <span class="currency-tag">{{ item.Currency || '-' }}</span>
                            </td>
                            <td class="text-center text-muted">{{ item.Closest_Quantity ?? '-' }}</td>
                            <td class="text-center text-muted">{{ item.MOQ ?? '-' }}</td>
                        </tr>
                        <tr *ngIf="!selectedPart?.supplier_availability || selectedPart?.supplier_availability?.length === 0">
                            <td colspan="6" class="empty-supplier-state text-center py-4 text-muted">
                                <i class="fa fa-box-open me-2"></i> No supplier availability records available for this part.
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <!-- Footer -->
        <div class="custom-modal-footer">
            <button type="button" class="btn btn-close-modal" (click)="close()">
                Close
            </button>
        </div>
    </div>
</div>